import { getPlayoffLabel } from "./matchDetailDisplay";
import "./PlayoffBadge.scss";

const PlayoffBadge = ({ playoffType }: { playoffType?: string | null }) => {
  const label = getPlayoffLabel(playoffType);
  if (!label) return null;
  return (
    <span className={`playoff-badge${label === "Final" ? " playoff-badge--final" : ""}`}>
      {label}
    </span>
  );
};

export default PlayoffBadge;
